const projectsData = [
  {
    slug: "urf",
    title: "URF Radio Website",
    image: `${process.env.PUBLIC_URL}/images/projects/urf.png`,
    date: "15-02-2024",
    links: { website: "https://urfonline.com" },
    description: "URF is a radio show society at the University of Sussex. They approached me and commissioned me to create a designed website with a functional dashboard included. It took about 250 hours of work and a lot of client meetings, but it got completed and is fully operational."
  },
  {
    slug: "easy-trip-planner",
    title: "Easy Trip Planner",
    image: `${process.env.PUBLIC_URL}/images/projects/easytripplanner.png`,
    date: "26-04-2025",
    links: { github: "https://github.com/natbates/EventPlannerFront", website: "https://easytripplanner.uk" },
    description: "With the sole goal of making planning holidays easier with my friends and family, I set about making my own personal shared calendar website with plenty of useful features including: polls, links, to-do list, comments, and dynamic locations. I created all the drawings and set up the front end, back end, and the server."
  },
  {
    slug: "elainekeep",
    title: "Elaine Keep",
    image: `${process.env.PUBLIC_URL}/images/projects/elainekeep.png`,
    date: "01-09-2025",
    links: { website: "https://elainekeep.com" },
    description: "Elaine is my older sister who is a freelance B2B copy writer. She asked me to make her a engaging pink theme portfolio to showcase her skills and previous works. It took a few design iterations but I really like how it turned out in the end!"
  },
  {
    slug: "hacksussex",
    title: "Hack Sussex Website",
    image: `${process.env.PUBLIC_URL}/images/projects/hacksussex.png`,
    date: "28-02-2026",
    links: { website: "https://hacksussex.com" },
    description: "Hack Sussex is a committee at the University of Sussex which organizes hackathon events. I was responsible for designing and developing their official website, which allows participants to register for events, view schedules, and access resources."
  },
  {
    slug: "xxzxcuzx",
    title: "xxzxcuzx",
    image: `${process.env.PUBLIC_URL}/images/projects/xxzxcuzx.png`,
    date: "17-03-2026",
    links: { website: "https://www.xxzxcuzx.com" },
    description: "xxzxcuzx is a (kind of) portfolio website I built for my flatmate who is a game developer. It is a uniquely styled website that has a custom design and features a gallery, their games, software and lots of secret easter eggs. It was fun to make with him and I like how it turned out"
  },
  {
    slug: "the1985nes",
    title: "The 1985 NES Showcase",
    image: `${process.env.PUBLIC_URL}/images/projects/the1985nes.png`,
    date: "10-05-2026",
    links: { website: "https://the1985nes.netlify.app" },
    description: "This website was developed for my Web 3D applications coursework module in my last year of Universtiy. It uses React and Three.Js to showcase some old nintendo product models that I built myself in blender. I recorded the sound effects and uploaded images of my flatmates collection I used for referencing. It turned out amazing so I thought i would flex it on here!"
  }
];

export default projectsData;
